import type { EventContext } from "@/instrumentation/logger/types"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import type { NftId, NftMiniature } from "@anaconda/core/nft/types"
import type { PriceValue } from "@anaconda/core/price/types"
import type { Blockchain } from "@rarible_int/anaconda_sdk/ethereum"
import Big from "big.js"

export interface NftListEventProps {
  ids: NftId[]
  price?: PriceValue
  collection: NftMiniature["collection"]
}
export function getBaseNftListEventContext({
  ids,
  price,
  collection,
}: NftListEventProps) {
  const serializedIds = ids.join(", ")
  const context: EventContext = {
    ids: serializedIds,
    collectionId: collection.id,
    blockchain: collection.blockchain,
  }

  if (price) {
    context.priceAmount = price.amount.toString()
    context.priceCurrency = price.currency.abbreviation
  }

  if (price?.currency.usdExchangeRate) {
    context.priceInUsd = Big(price.amount)
      .times(price.currency.usdExchangeRate)
      .toString()
  }

  return context
}

export interface NftEventProps {
  id: NftId
  price?: PriceValue
  collection: NftMiniature["collection"]
}
export function getBaseNftEventContext({
  id,
  collection,
  price,
}: NftEventProps) {
  const context: EventContext = {
    nftId: id,
    collectionId: collection.id,
    blockchain: collection.blockchain,
  }

  if (price) {
    context.priceAmount = price.amount.toString()
    context.priceCurrency = price.currency.abbreviation
  }

  if (price?.currency.usdExchangeRate) {
    context.priceInUsd = Big(price.amount)
      .times(price.currency.usdExchangeRate)
      .toString()
  }

  return context
}

export interface NftMintEventProps {
  collectionId: CollectionId
  blockchain: Blockchain
}
export function getBaseMintNftEventContext({
  collectionId,
  blockchain,
}: NftMintEventProps) {
  return {
    collectionId,
    blockchain,
  } as const
}
